export default {
  fullPathBeforeLoginRegister: null,
  reviewedItems: [],
  notifications: [],
  dismissedNotifications: [],
  clanPedigreeDetailsPreviousRoute: {},
  previousRoute: {},

  showCardQuickEditTooltip: false,
  showCardQuickViewTooltip: false,
  showCardFullProfileTooltip: false,
  showCardAddRelativeTooltip: false,

  nextVerifyNotificationTime: null,
  storiesRecentTags: {},
};
